// Module
var code = `<div class="ent-horde__chosen-option"
     ng-click="\$ctrl.showDropdown = !\$ctrl.showDropdown"
     ng-class="\$ctrl.showDropdown ? 'expanded' : 'collapsed'"
>
  {{\$ctrl.labelRenderer()}}
</div>
<div class="ent-horde__tree-wrapper">
  <div class="ent-horde__tree-element" ng-show="\$ctrl.showDropdown"></div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/ent-horde/ent-horde.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;